import {Component, Injectable, OnDestroy, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Account, LoginFormModel, LoginService, Stormpath, StormpathErrorResponse} from 'angular-stormpath';
import {ActivatedRoute, Router} from '@angular/router';
import {FormErrors} from '../../components/forms/validation/form-validator.class';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {FormManager, FormSubmissionStatusCode} from '../../components/forms/form-manager.class';
import {AuthService} from '../../components/security/authorization/auth.service';
import {rootRoutePath as personalDetailsPath} from '../personal-details/personal-details-page.routing';
import {rootRoutePath as dashboardPath} from '../dashboard/dashboard-page.routing';
import {Subscription} from 'rxjs/Subscription';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {CapslockDetector} from '../../components/forms/validation/capslock/capslock-detector.class';

@Component({
    template: require('./login-page.component.html'),
    styles: [require('./login-page.component.scss')]
})
@Injectable()
export class LoginPageComponent implements OnDestroy {

    @ViewChild('capslockTooltip') private readonly _capslockTooltip: NgbTooltip;

    protected loginFormModel: LoginFormModel;
    protected user$: Observable<Account | boolean>;
    protected loggedIn$: Observable<boolean>;
    protected error: string | null;

    readonly form$ = new ReplaySubject<NgForm>(1);
    formErrors: FormErrors = {};
    private readonly _formManager: FormManager<Account>;

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    subscriptions: Subscription[] = [];

    private _capslockDetector = new CapslockDetector();

    loggingIn: boolean = false;

    get loginButtonDisabledValue(): string | null {
        return this.loggingIn ? '' : null;
    }

    constructor(public stormpath: Stormpath,
                public router: Router,
                public activatedRoute: ActivatedRoute,
                public loginService: LoginService,
                public authService: AuthService,
                fmgm: FormManager.InjectedMembers) {

        this.user$ = this.stormpath.user$;
        this.loggedIn$ = this.user$.map(user => !!user);
        this.loginFormModel = {
            login: '',
            password: ''
        };

        this._formManager = new FormManager<Account>(
            fmgm,
            this.form$,
            Observable.of(() => this.stormpath.login(this.loginFormModel)),
            undefined,
            false
        );
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);

        // TODO move to authGuard? redirect authenticated users that try to reach login/register...
        this.subscriptions.push(this.authService.user$.subscribe(user => {
            if (user) this._navigateLoggedInUser(user.firstLogin);
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(it => it.unsubscribe());
    }

    login(): void {
        this.error = null;
        this.loggingIn = true;
        // TODO encapsulate in loginservice and externalize configuration (default redirect...)
        this._formManager.save()
            .subscribe(result => {
                    if (result.status.code !== FormSubmissionStatusCode.SUBMITTED) this.loggingIn = false;
                },
                (error: StormpathErrorResponse) => {
                    let errorMessage = error.message;
                    switch (errorMessage) {
                        case 'Invalid grant':
                        case 'The credentials provided were invalid.':
                            errorMessage = 'Authentication failed. Please verify the login credentials.';
                            break;
                        case 'API call exceeded rate limit due to too many requests.':
                            errorMessage = 'Too many attempts. Please try again in some time.';
                    }
                    this.error = errorMessage;
                    this.loggingIn = false;
                });
    }

    forgot(): void {
        this.loginService.forgotPassword();
    }

    private _navigateLoggedInUser(firstLogin: boolean): void {
        this.router.navigateByUrl(firstLogin ? personalDetailsPath : (this.activatedRoute.snapshot.params['redirect'] || dashboardPath));
    }

    handlePasswordInputKeypress(event: KeyboardEvent) {
        if (this._capslockDetector.isCapslockOn(event)) this._capslockTooltip.open();
        else this._capslockTooltip.close();
    }

    handlePasswordInputBlur() {
        this._capslockTooltip.close();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/login/login-page.component.ts